// src/utils/request.js
import axios from 'axios';
import store from '@/store';

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://your-api.com', // 可选，从 .env 文件读取
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 统一添加请求头 X-Request-Corpno
    config.headers['X-Requested-With'] = store.state.info.corp_no; // ← 替换为你的实际企业编号

    // 如果你有动态值（比如从 localStorage 或 Vuex 获取），也可以这样写：
    // const corpno = localStorage.getItem('corpno') || 'default';
    // config.headers['X-Request-Corpno'] = corpno;

    return config;
  },
  (error) => {
    console.error('请求拦截失败:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器（可选）
request.interceptors.response.use(
  (response) => {
    return response.data; // 直接返回 data，调用时无需 .data
  },
  (error) => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default request;